<template>
  <div class="wing-layout">
    <div class="main-wrap">
      <div class="wrapper">
        <div class="table-agile-info">
          <jm-crumbs/>
          <el-tabs
            class="message-record"
            @tab-click="historyClick">
            <el-tab-pane label="发送消息">
              <el-row>
                <el-col :span="8">
                  <label>申请学校：</label>
                  <jm-school-search
                    :country-id="83"
                    v-model="infoData.schoolV"
                    clearable/>
                </el-col>
                <el-col :span="8">
                  <label>户籍所在：</label>
                  <jm-areaselect v-model="infoData.domicile"/>
                </el-col>
                <el-col :span="8">
                  <label>学历：</label>
                  <el-select
                    class="jm-input280"
                    v-model="infoData.highestRecord1"
                    placeholder="请选择"
                    clearable>
                    <el-option
                      v-for="item in recordInfoData.education"
                      :key="item.dic_key"
                      :label="item.dic_value"
                      :value="item.dic_key"/>
                  </el-select>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <label>办理状态：</label>
                  <el-radio-group v-model="infoData.enrollmentStatus">
                    <el-radio
                      v-for="item in recordInfoData.enrollmentStatus"
                      :label="item.dic_key"
                      :key="item.dic_key">{{ item.dic_value }}</el-radio>
                  </el-radio-group>
                </el-col>
                <el-col :span="8">
                  <label>入学时间：</label>
                  <el-date-picker
                    class="jm-input135"
                    v-model="infoData.admissionTimeAl"
                    type="month"
                    format="yyyy-MM"
                    value-format="yyyy-MM"
                    :picker-options="starDateOpt"
                    placeholder="请选择"
                    @change="converYearMonth"/>
                </el-col>
                <el-col :span="8"/>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-button
                    type="primary"
                    @click="addFilter"
                    size="small">添加筛选条件</el-button>
                  <el-button
                    type="primary"
                    @click="resetFilter"
                    size="small">重置条件</el-button>
                </el-col>
              </el-row>
              <el-row
                class="record-filter-wrap"
                v-if="callbackData.condition">
                <el-col :span="24">
                  <div class="record-filter-num">共有<b>{{ callbackData.count }}</b>条符合条件的记录</div>
                  <div class="record-filter">
                    <span
                      v-for="(item, index) in callbackData.condition"
                      :key="index">{{ item }}</span>
                  </div>
                </el-col>
              </el-row>
              <el-tabs
                type="border-card"
                class="record-wrap"
                @tab-click="recordTab">
                <el-tab-pane :label="recordInfoTitle[0]">
                  同学们家长们，大家好！<br>经过申请材料的精心准备，同学们的材料即将递交进入管局进行审核，具体递交时间如下：（
                  <el-input
                    class="jm-input90 year"
                    size="mini"
                    v-model="submitData._0[0]"
                    placeholder="年"
                    :disabled="true"/>
                  年
                  <el-input
                    class="jm-input50 month"
                    size="mini"
                    v-model="submitData._0[1]"
                    placeholder="月"
                    :disabled="true"/>
                  月生，提交入管局时间东京
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._0[2]"
                    placeholder="月"/>
                  月
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._0[3]"
                    placeholder="日"/>
                  日，大阪
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._0[4]"
                    placeholder="月"/>
                  月
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._0[5]"
                    placeholder="日"/>
                  日，名古屋
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._0[6]"
                    placeholder="月"/>
                  月
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._0[7]"
                    placeholder="日"/>
                  日，福冈
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._0[8]"
                    placeholder="月"/>
                  月
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._0[9]"
                    placeholder="日"/>
                  日）其中不包含申请专门学校、大学、准备教育课程的同学，这类同学在留资格随递随签，无指定递交时间，学校老师会在确认材料无误后递交进入管局。如需确认是否已经递交，请联系自己的文案老师。
                </el-tab-pane>
                <el-tab-pane
                  :label="recordInfoTitle[1]"
                  name="3">
                  同学们家长们，大家好！<br>在入管局审核期间会有一定几率进行电话调查 ，电话调查的回答会直接影响到在留资格审查的结果，所以务必认真准备。文案老师们为同学们整理了历年电调的问题集，虽无法全部包含，但对大家准备应对电调会有很大帮助，请大家一定认真对待。打开问题集：http://t.cn/RKsTUss
                </el-tab-pane>
                <el-tab-pane
                  :label="recordInfoTitle[2]"
                  name="2">
                  同学们家长们，大家好！<br>为了帮助同学们能够更顺利地在日本读书，无后顾之忧，芥末网为大家提供后期一系列服务，包括宿舍及房屋租赁、手机办理、宽带办理、卡西欧团购等等。尽快联系文案老师了解相关服务。
                </el-tab-pane>
                <el-tab-pane
                  :label="recordInfoTitle[3]"
                  name="16">
                  同学们家长们，大家好！<br>在留资格审查已经接近尾声，各入管局将在以下时间发布在留资格的审查结果：（
                  <el-input
                    class="jm-input90 year"
                    size="mini"
                    v-model="submitData._3[0]"
                    placeholder="年"
                    :disabled="true"/>
                  年
                  <el-input
                    class="jm-input50 month"
                    size="mini"
                    v-model="submitData._3[1]"
                    placeholder="月"
                    :disabled="true"/>
                  月生，交付时间，东京
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._3[2]"
                    placeholder="月"/>
                  月
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._3[3]"
                    placeholder="日"/>
                  日，大阪
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._3[4]"
                    placeholder="月"/>
                  月
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._3[5]"
                    placeholder="日"/>
                  日，名古屋
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._3[6]"
                    placeholder="月"/>
                  月
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._3[7]"
                    placeholder="日"/>
                  日，福冈
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._3[8]"
                    placeholder="月"/>
                  月
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._3[9]"
                    placeholder="日"/>
                  日）其中不包含申请专门学校、大学、准备教育课程的同学，学校老师们收到这类同学在留资格审核结果后会第一时间通知芥末的老师们，老师们会立刻告知大家。<br>为了帮助同学们更加顺利地进行接下来的手续，我们将在
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._3[10]"
                    placeholder="月"/>
                  月
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._3[11]"
                    placeholder="日"/>
                  日
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._3[12]"
                    placeholder="时间"/>
                  点，通过
                  <el-input
                    class="jm-input135"
                    size="mini"
                    v-model="submitData._3[13]"
                    placeholder="举办平台"/>
                  平台举行给（
                  <el-input
                    class="jm-input90 year"
                    size="mini"
                    v-model="submitData._3[14]"
                    placeholder="年"
                    :disabled="true"/>
                  年
                  <el-input
                    class="jm-input50 month"
                    size="mini"
                    v-model="submitData._3[15]"
                    placeholder="月"
                    :disabled="true"/>
                  月生们）的专场行前指导，其中包含交学费、签证办理等重要事项，请大家务必参加。
                </el-tab-pane>
                <el-tab-pane
                  :label="recordInfoTitle[4]"
                  name="15">
                  亲爱的（
                  <el-input
                    class="jm-input135"
                    size="mini"
                    v-model="submitData._4[0]"
                    placeholder="学校"
                    :disabled="isSchool"/>
                  <el-input
                    class="jm-input90 year"
                    size="mini"
                    v-model="submitData._4[1]"
                    placeholder="年"
                    :disabled="true"/>
                  年
                  <el-input
                    class="jm-input50 month"
                    size="mini"
                    v-model="submitData._4[2]"
                    placeholder="月"
                    :disabled="true"/>
                  月生）您好！<br>恭喜顺利取得在留资格。您申请的
                  <el-input
                    class="jm-input135"
                    size="mini"
                    v-model="submitData._4[3]"
                    placeholder="学校"
                    :disabled="isSchool"/>
                  接机时间是（
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._4[4]"
                    placeholder="月" />
                  月
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._4[5]"
                    placeholder="日"/>
                  日，请购买
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._4[6]"
                    placeholder="时间"/>
                  点到
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._4[7]"
                    placeholder="时间"/>
                  点之间抵达
                  <el-input
                    class="jm-input135"
                    size="mini"
                    v-model="submitData._4[8]"
                    placeholder="机场名"/>
                  机场的机票，个别学校只给住校生提供接机，请与文案老师进行确认~）。<br>同时，芥末网为了给大家提供更周到的服务，也将在（
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._4[9]"
                    placeholder="月"/>
                  月
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._4[10]"
                    placeholder="日"/>
                  日）为芥末的学生们提供专属的接机服务，接机时间是（
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._4[11]"
                    placeholder="月"/>
                  月
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._4[12]"
                    placeholder="日"/>
                  日请购买
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._4[13]"
                    placeholder="时间"/>
                  点到
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._4[14]"
                    placeholder="时间"/>
                  点之间抵达机场的机票~）。建议大家签证下达后再购买机票，请同学们购买好机票之后，告知文案老师以下信息：航班信息和是否需要接机，需要学校还是芥末接机。<br>祝大家一切顺利，芥末似锦。
                </el-tab-pane>
                <el-tab-pane
                  :label="recordInfoTitle[5]"
                  name="8">
                  您好！我们将在
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._5[0]"
                    placeholder="月"/>
                  月
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._5[1]"
                    placeholder="日"/>
                  日
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._5[2]"
                    placeholder="时间"/>
                  —
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._5[3]"
                    placeholder="时间"/>
                  ，于
                  <el-input
                    class="jm-input135"
                    size="mini"
                    v-model="submitData._5[4]"
                    placeholder="举办平台"/>
                  举行
                  <el-input
                    class="jm-input135"
                    size="mini"
                    v-model="submitData._5[5]"
                    placeholder="活动名"/>
                  。我们诚邀您与您的家人、朋友共同出席.期盼您的莅临！详细地址：
                  <el-input
                    class="jm-input220"
                    size="mini"
                    v-model="submitData._5[6]"
                    placeholder="详细地址"/>
                  。请添加芥末老师的微信号：
                  <el-input
                    class="jm-input135"
                    size="mini"
                    v-model="submitData._5[7]"
                    placeholder="微信"/>
                  。我们会给你发会场地图和最新的留学资讯哦！
                </el-tab-pane>
                <el-tab-pane
                  :label="recordInfoTitle[6]"
                  name="7">
                  您好！我们将在
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._6[0]"
                    placeholder="月"/>
                  月
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._6[1]"
                    placeholder="日"/>
                  日
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._6[2]"
                    placeholder="时间"/>
                  —
                  <el-input
                    class="jm-input50"
                    size="mini"
                    v-model="submitData._6[3]"
                    placeholder="时间"/>
                  ， 在
                  <el-input
                    class="jm-input135"
                    size="mini"
                    v-model="submitData._6[4]"
                    placeholder="举办平台"/>
                  平台举办
                  <el-input
                    class="jm-input135"
                    size="mini"
                    v-model="submitData._6[5]"
                    placeholder="活动名"/>
                  活动。活动内容： 我们诚邀您报名参加！请添加芥末老师的微信号：
                  <el-input
                    class="jm-input135"
                    size="mini"
                    v-model="submitData._6[6]"
                    placeholder="微信"/>
                  。我们老师会给您发送活动报名链接哦！
                </el-tab-pane>
                <el-tab-pane
                  :label="recordInfoTitle[7]"
                  name="1">
                  <el-input
                    type="textarea"
                    v-model="submitData._7[0]"
                    placeholder="消息提醒"/>
                </el-tab-pane>
                <el-button
                  class="record-send-button"
                  @click="sendMessage"
                  type="primary"
                  size="small"
                  :loading="sendIsLoading">{{ !sendIsLoading ? '确认发送' : '发送中...' }}</el-button>
              </el-tabs>
            </el-tab-pane>
            <el-tab-pane
              label="历史消息"
              name="history-active">
              <jm-tableList
                :url="`index/Process/msgList`"
                :refresh="refresh">
                <el-table-column
                  slot="condition"
                  label="发送筛选条件"
                  width="200">
                  <template slot-scope="scope">
                    <div class="history-record-filter">
                      <span
                        v-for="(item, index) in scope.row.condition"
                        :key="index">{{ item }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  slot="content"
                  label="内容">
                  <template slot-scope="scope">
                    <div v-html="scope.row.content"/>
                  </template>
                </el-table-column>
              </jm-tableList>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import tableList from '@/components/data/tableList.vue';
import { crumbs, jmSchoolSearch, jmAreaselect } from '@/components/tool/index.js';

export default {
  data() {
    return {
      currentTabIndex: 0,
      currentInputLength: 10,
      starDateOpt: { // 时间控件 只有 1 4 7 10 月份
        disabledDate(time) {
          return (time.getMonth() % 3) !== 0 || (time.getFullYear() < (new Date()).getFullYear());
        }
      },
      recordInfoTitle: {}, // 卡片标题
      callbackData: {}, // 返回数据
      recordInfoData: [], // 初始化数据
      infoData: { // v-model 及 发送data数据
        highestRecord1: '',
        enrollmentStatus: 1,
        admissionTimeAl: '',
        schoolV: {},
        domicile: [],
        recordSchoolDateYear: '',
        recordSchoolDateMonth: ''
      },
      submitData: {
        _0: [],
        _1: [],
        _2: [],
        _3: [],
        _4: [],
        _5: [],
        _6: [],
        _7: [],
      },
      isSchool: true, // 默认 入学通知 学校是不可修改
      sendIsLoading: false,
    };
  },
  computed: {
    /*
    * 状态刷新
    * */
    refresh() {
      return this.$store.state.student.refresh;
    }
  },
  components: {
    'jm-crumbs': crumbs, // 面包屑
    'jm-tableList': tableList,
    jmSchoolSearch,
    jmAreaselect,
  },
  mounted() {
    this.getRecordInfo();
  },
  methods: {
    /*
    * 初始化数据
    * */
    getRecordInfo() {
      this.$http._get({
        url: '/index/Process/msgConfig'
      }).then((res) => {
        if (res.result !== -1) {
          this.recordInfoData = res.data;
          this.recordInfoData.type.forEach((item, index) => {
            this.recordInfoTitle[index] = item.dic_value;
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    /*
    * 拆分 年 月 日
    * */
    converYearMonth() {
      if (this.infoData.admissionTimeAl !== null) {
        let admissionDate = new Date(this.infoData.admissionTimeAl);
        let startSchoolDateYear = admissionDate.getFullYear();
        let startSchoolDateMonth = admissionDate.getMonth() + 1;
        this.infoData.recordSchoolDateYear = startSchoolDateYear;
        this.infoData.recordSchoolDateMonth = startSchoolDateMonth;
      } else {
        this.infoData.recordSchoolDateYear = null;
        this.infoData.recordSchoolDateMonth = null;
      }
    },
    /*
    * 添加筛选条件
    * */
    addFilter() {
      this.$http._post({
        url: '/index/Process/searchMsgStudent',
        data: {
          searchData: this.infoData
        }
      }).then((res) => {
        if (res.result !== -1) {
          this.callbackData = res.data;
          if (this.callbackData.searchData.schoolV !== undefined &&
            this.callbackData.searchData.schoolV !== null) {
            if (Object.keys(this.callbackData.searchData.schoolV).length) {
              let school = this.callbackData.searchData.schoolV.sh_name_cn;
              this.isSchool = false;
              this.submitData._4[0] = school;
              this.submitData._4[3] = school;
            }
          }
          let year = this.callbackData.searchData.recordSchoolDateYear;
          let month = this.callbackData.searchData.recordSchoolDateMonth;
          this.submitData._0[0] = year;
          this.submitData._0[1] = month;
          this.submitData._3[0] = year;
          this.submitData._3[1] = month;
          this.submitData._3[14] = year;
          this.submitData._3[15] = month;
          this.submitData._4[1] = year;
          this.submitData._4[2] = month;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    /*
    * 重置添加筛选条件
    * */
    resetFilter() {
      this.callbackData = {};
      Object.keys(this.submitData).forEach((k) => {
        this.submitData[k] = [];
      });
      Object.keys(this.infoData).forEach((k) => {
        this.infoData[k] = null;
      });
      this.infoData.enrollmentStatus = 1;
      this.isSchool = true;
    },
    /*
    * 判断选中哪一个tab
    * */
    recordTab(tab) {
      this.currentTabIndex = (tab.index || 0) - 0;
      this.currentInputLength = (tab.name || 10) - 0;
    },
    /*
    *  刷新历史消息页面
    * */
    historyClick() {
      this.$store.commit('updateRefresh', true);
    },
    /*
    * 发送消息
    * */
    sendMessage() {
      let data = this.submitData[`_${this.currentTabIndex}`];
      let type = this.recordInfoData.type[this.currentTabIndex].dic_key;
      let isData = false;
      for (let i = 0; i < this.currentInputLength; i++) {
        if (typeof data[i] === 'undefined') {
          data[i] = '';
        }
      }
      if (this.currentTabIndex === 4) {
        for (let i = 0; i <= data.length; i++) {
          if (data[0] !== '' && data[0] !== null && data[3] !== '' && data[3] !== null) {
            if (data[i] === '' || data[i] === null) {
              this.$message.error('输入内容不能为空');
              isData = false;
              break;
            } else {
              isData = true;
            }
          } else {
            this.$message.error('请添加申请学校');
          }
        }
      } else {
        for (let i = 0; i <= data.length; i++) {
          if (data[i] === '' || data[i] === null) {
            if (this.currentTabIndex !== 1 && this.currentTabIndex !== 2) {
              this.$message.error('输入内容不能为空');
              isData = false;
              break;
            }
          } else {
            isData = true;
          }
        }
      }
      let sendData = {
        searchData: this.callbackData.searchData,
        type,
        fields: (this.currentTabIndex !== 1 && this.currentTabIndex !== 2) ? data : []
      };
      if (Object.keys(this.callbackData).length) {
        if (isData) {
          this.$confirm('确认要发送？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.sendIsLoading = true;
            this.$http._post({
              url: '/index/Process/sendMsg',
              data: sendData
            }).then((res) => {
              if (res.result !== -1) {
                this.sendIsLoading = false;
                this.$message.success('发送成功');
                this.resetFilter();
                this.infoData.highestRecord1 = '';
                this.infoData.admissionTimeAl = '';
              }
            }).catch(() => {
              this.sendIsLoading = false;
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消发送'
            });
          });
        }
      } else {
        this.$message.error('请添加筛选条件');
      }
    }
  },
};
</script>
<style scoped>
  .message-record .el-row{
    margin-bottom: 10px;
  }
  .record-filter-wrap{
    margin-top: 20px;
  }
  .record-filter-num b{
    padding: 0 4px;
    color: #f00;
  }
  .record-filter{
    margin-top: 15px;
  }
  .record-filter span{
    margin-right:8px;
    border-radius: 10px;
    border: 1px solid #bfcbd9;
    padding: 2px 6px;
  }
  .history-record-filter{
    margin: 6px;
  }
  .history-record-filter span{
    display: inline-flex;
    border-radius: 10px;
    border: 1px solid #bfcbd9;
    padding: 2px 6px;
    margin: 4px 0;
  }
  .record-wrap{
    margin-top: 30px;
    line-height: 28px;
  }
  .record-send-button{
    margin-top: 10px;
    float: right;
  }
</style>
